/* eslint-disable no-restricted-syntax */
import React, { useState } from 'react';
import { Radio } from 'antd';
import ReactCardFlip from 'react-card-flip';

const FlipGraph = ({ Graph1, Graph2 }) => {
    const [isFlipped, setFlipped] = useState(false);
    const options = [
        { label: Graph1.optionName, value: Graph1.optionName },
        { label: Graph2.optionName, value: Graph2.optionName },
    ];

    const Card = ({ children }) => (
        <div
            style={{
                backgroundColor: 'rgb(251, 251, 251)',
            }}
        >
            {children}
        </div>
    );

    return (
        <>
            <Radio.Group
                block
                optionType="button"
                buttonStyle="solid"
                options={options}
                defaultValue={Graph1.optionName}
                onChange={() => setFlipped(!isFlipped)}
                size="small"
                style={{ marginBottom: '5px', textAlign: 'right', width: '80%' }}
            />

            <ReactCardFlip isFlipped={isFlipped} flipDirection="horizontal">
                <Card>
                    <div>{Graph1.graph}</div>
                </Card>
                <Card>
                    <div>{Graph2.graph}</div>
                </Card>
            </ReactCardFlip>
            {/* <div className={`flip-card ${isFlipped ? 'flipped' : ''}`}>
                <div className="flip-card-inner">
                    <div className="flip-card-front">{Graph1.graph}</div>
                    <div className="flip-card-back">{Graph2.graph}</div>
                </div>
            </div> */}
        </>
    );
};

export default FlipGraph;
